import React, { Component } from "react";
import { message, Row, Col, Switch, Alert } from "antd";
import { MobileOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  ButtonItem,
  ErrorItem,
} from "../../../Components/Items";

class ModalAccesoApp extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.formRef.current?.setFieldsValue({
        accesoApp: !!this.props.accesoAppActual,
      });
    }
  }

  cerrarModal(exitoso = false) {
    this.formRef.current?.resetFields();
    if (exitoso) {
      this.props.onSuccess?.();
    } else {
      this.props.onCancel?.();
    }
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "usuarios/actualizarAccesoApp",
        { usuarioId: this.props.usuarioId, accesoApp: !!values.accesoApp },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Acceso a la app actualizado correctamente");
          this.cerrarModal(true);
        } else {
          message.error("Ocurrió un error, inténtalo de nuevo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error de conexión");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const { visible, usuarioNombre } = this.props;
    const { loading } = this.state;

    return (
      <ModalItem
        title={
          <span>
            <MobileOutlined style={{ marginRight: 8 }} />
            Acceso a la App
          </span>
        }
        visible={visible}
        spinning={loading}
        onCancel={() => this.cerrarModal()}
        width={480}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="formAccesoApp"
          layout="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          bottom={
            <Row justify="end" gutter={8}>
              <Col>
                <ButtonItem rojo onClick={() => this.cerrarModal()}>
                  Cancelar
                </ButtonItem>
              </Col>
              <Col>
                <ButtonItem type="primary" htmlType="submit">
                  Guardar
                </ButtonItem>
              </Col>
            </Row>
          }
        >
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
            message={
              usuarioNombre
                ? `Configura el acceso a la app para ${usuarioNombre}.`
                : "Configura el acceso a la app."
            }
            description="Se usarán el mismo usuario y contraseña del ERP para el acceso a la app."
          />
          <FormItem
            label="Acceso a la app"
            name="accesoApp"
            valuePropName="checked"
            margin
          >
            <Switch checkedChildren="Activo" unCheckedChildren="Inactivo" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalAccesoApp);
